import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Const, LiquidacionNoPaga, ExpedienteLiquidacion } from '@app/shared';
import { EndpointService } from '@app/core';

@Injectable()
export class ProjectLiquidationDataService {

  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) {}

  /**
   * Consulta las liquidaciones no pagas
   *
   * @returns {Observable<Liquidaciones[]>}
   * @memberof ProjectLiquidationDataService
   */
  getUnpaidLiquidations(): Observable<LiquidacionNoPaga[]> {
    return new Observable(obs => {
      this.http.get<LiquidacionNoPaga[]>( Const.ROUTES_SYSTEM_INTEGRATIONS.cita.urlLiquidations, {
            observe: 'response'
          }
        )
        .subscribe(
          res => {
            obs.next(res.body);
          },
          err => {
            obs.error(err);
          }
        );
    });
  }

  /**
   * Consulta las liquidaciones no pagas de un expediente
   * Se puede indicar traer todas las liqidaciones sin pago si no hay para el expediente
   *
   * @returns {Observable<Liquidacion[]>}
   * @memberof ProjectLiquidationDataService
   */
  getUnpaidLiquidationsExpediente(idTask: number, all: boolean = false): Observable<LiquidacionNoPaga[]> {
    const formData = {
      idtarea: idTask,
    };
    if (all) {
      formData['todos'] = true;
    }

    return new Observable(obs => {
      this.http.post<LiquidacionNoPaga[]>( this.api.get('liquidations'), formData, {
            observe: 'response'
          }
        )
        .subscribe(
          res => {
            obs.next(res.body);
          },
          err => {
            obs.error(err);
          }
        );
    });
  }

  getExpediente(idTask: number): Observable<ExpedienteLiquidacion> {

    return new Observable(obs => {
      this.http.get<ExpedienteLiquidacion>( this.api.get('taskExpediente', [idTask]), {
            observe: 'response'
          }
        )
        .subscribe(
          res => {
            obs.next(res.body);
          },
          err => {
            obs.error(err);
          }
        );
    });
  }

  /**
   * Realiza la asociacion de el expediente con la liquidacion indicada
   *
   * @param {number} idTask
   * @param {number} idLiquidation
   * @returns {Promise<boolean>}
   * @memberof ProjectLiquidationDataService
   */
  associationLiquidationExpediente(idTask: number, idLiquidation: number): Promise<boolean> {
    const formData = {
      idtarea: idTask,
      idliquidacion: idLiquidation
    };
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().put<any[]>( this.api.get('liquidation'), formData, {
            observe: 'response'
          }
        )
        .subscribe(
          _res => {
            this.toastr.success('Liquidación asociada correctamente', 'Operación exitoxa');
            resolve(true);
          },
          err => {
            if (err.error['liquidacion_existente']) {
              this.toastr.warning(err.error['liquidacion_existente'], 'Error en operación');
            } else if (err.error['id_expediente_cita']) {
              this.toastr.warning(err.error['id_expediente_cita'], 'Error en operación');
            } else {
              this.toastr.error('Se produjo un error al realizar la petición al servidor.', 'Ocurrió un error');
            }
            reject(err);
          }
        );
    });
  }

  /**
   * Actualiza el documento de la liquidacion con el de cinco
   *
   * @param {number} idLiquidation
   * @param {number} idDocumento
   * @returns {Observable<boolean>}
   * @memberof ProjectLiquidationDataService
   */
  getUpdateDocumentLiquidation(idLiquidation: number, idDocumento: number): Observable<boolean> {
    const data = '?idliquidacion=' + idLiquidation + '&iddocumento_cinco=' + idDocumento + '&DBGSESSID=1';
    return new Observable(obs => {
      this.http.put<boolean>( Const.ROUTES_SYSTEM_INTEGRATIONS.cita.urlLiquidation + data, {}, {
        observe: 'response'
      })
        .subscribe(
          res => {
            obs.next(true);
          },
          err => {
            obs.error(err);
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/all/project-liquidation/shared/project-liquidation.data.service.ts